// App.js
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import "./login.css";
import recalllogo from "../assets/images/recalllogo.png";
import axios from "axios";
import { BASE_URL, ERROR, ROUTES } from "../assets/constant";
import Messages from "../components/message";
import { useDispatch, useSelector } from "react-redux";
import { loggedIn, setOtpEmail } from "../redux/authSlice";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeSlashFill } from "react-bootstrap-icons";

export function Login() {
  const [form, setForm] = useState({});
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTES.DASHBOARD, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const getRealSubscriptions = async (userId, token) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/recall/v1/get-subscriptions`,
        { user_id: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data.subscriptions || [];
    } catch (error) {
      console.error("Error fetching real subscriptions:", error);
      return [];
    }
  };

  const dispatch = useDispatch();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${BASE_URL}/users/v2.0/login`, {
        email: form.email,
        password: form.password
      });

      if (response.data.two_factor_enabled) {
        dispatch(setOtpEmail(form.email));
        navigate("/verify-otp");
        return;
      }

      const token = response?.data?.token;
      const userId = response?.data?.user?.id;

      const realSubscriptions = await getRealSubscriptions(userId, token);

      dispatch(
        loggedIn({
          isAuthenticated: true,
          user: response?.data?.user,
          token: response?.data?.token,
          subscription: realSubscriptions // Use manage subscription api data, not login API data
          // subscription: response?.data?.subscriptions
        })
      );
      if (realSubscriptions.length > 0) {
        navigate(ROUTES.DASHBOARD, { replace: true });
      } else {
        navigate(ROUTES.MANAGE_SUBSCRIPTION, { replace: true });
      }
    } catch (error) {
      setAlertType(ERROR);
      setAlertMessage(error?.response?.data?.message || "Something went wrong");
      setShowAlert(true);
    }
  };

  const clickHandler = () => {
    const passwordInput = document.querySelector('input[name="password"]');
    if (passwordInput) {
      passwordInput.type = showPass ? "password" : "text";
    }
    setShowPass((prev) => !prev);
  };

  const inserData = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  return (
    <div className="login-page">
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Row className="login-container">
          {/* Image Section */}
          <Col md={6} className="image-section"></Col>

          {/* Form Section */}
          <Col md={6} className="form-section">
            <img src={recalllogo} alt="" />
            <Form onSubmit={handleSubmit}>
              {showAlert && (
                <Messages
                  type={alertType}
                  message={alertMessage}
                  onClose={() => setShowAlert(false)}
                />
              )}
              <Form.Group controlId="formBasicEmail" className="mb-3">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  value={form["email"]}
                  onChange={(e) => inserData("email", e.target.value)}
                  title="Please enter a valid email address"
                  required
                />
              </Form.Group>
              <Form.Group controlId="formBasicPassword" className="mb-3">
                <Form.Label>Password</Form.Label>
                <InputGroup className="mb-3">
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder="Password"
                    minLength={8}
                    value={form["password"]}
                    onChange={(e) => inserData("password", e.target.value)}
                    title="Password must be at least 8 characters"
                    required
                  />
                  <InputGroup.Text onClick={clickHandler}>
                    {showPass ? <EyeSlashFill /> : <Eye />}
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
              <Button
                variant="primary"
                type="submit"
                className={`recallButton w-100`}>
                Submit
              </Button>
            </Form>
            <div className="register-section">
              Don't have an account?{" "}
              <Link to={ROUTES.REGISTER}>Register Now</Link>
            </div>
            <div className="forgotpassword-section">
              <Link to={ROUTES.FORGOT_PASSWORD}>Forgot Password</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
